import { identity, isEmpty, pickBy } from 'lodash';

// eslint-disable-next-line @typescript-eslint/ban-types
export function hasFieldsWithValues(obj?: object) {
  if (!obj) return false;
  return !isEmpty(pickBy(obj, identity));
}
